import * as React from "react";
import { Policy } from "../../../../../../store/Policies/Types";
import { ThemeShadowSizes, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { licensePlate } from "@vwpfs/mary-air-lib/utils/FormatHelpers";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { FieldSet } from "@vwpfs/mary-air-lib/components/air/06-molecules/FieldSet";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";


interface Props {
    general: Policy;
}
/**
 *
 * @param props
 */
export const VehicleView: React.FC<Props> = (props: Props) => (
    <React.Fragment>
        <Div theme={{ shadow: ThemeShadowSizes.TINY }}>
            <Container
                theme={{
                    palette: ThemePalette.CONTRAST_PRIMARY,
                    padding: {
                        "": { y: 3 },
                        "sm": { y: 4 },
                    },
                }}
            >
                <Form>
                    <FieldSet title="Vehicle info">
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Brand"
                                    value={props.general.brand}
                                    asSummary
                                    type={FieldTypes.Text}
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Model"
                                    value={props.general.model}
                                    asSummary
                                    type={FieldTypes.Text}
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Vehicle Type"
                                    value={props.general.vehicleType}
                                    asSummary
                                    type={FieldTypes.Text}
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="License Plate"
                                    value={props.general.licensePlate ? licensePlate(props.general.licensePlate) : ""}
                                    asSummary
                                    type={FieldTypes.Text}
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Chassis Number"
                                    value={props.general.chassisNumber}
                                    asSummary
                                    type={FieldTypes.Text}
                                />
                            </Grid>
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Power"
                                    value={`${props.general.power} kW`}
                                    asSummary
                                    type={FieldTypes.Number}
                                />
                            </Grid>
                        </Div>
                        <Div className="scl-b-row">
                            <Grid
                                size={{ xs: 12, md: 4 }}
                            >
                                <FormField
                                    label="Start kilometers"
                                    value={props.general.mileage}
                                    asSummary
                                    type={FieldTypes.Number}
                                />
                            </Grid>
                        </Div>
                    </FieldSet>
                </Form>
            </Container>
        </Div>
    </React.Fragment>
);
